// @ts-nocheck
/**
 * @deprecated
 * Use the "Layout/SideColumnLayout" widget instead.
 */

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import constants from "@store/constants";
import AccountLayoutComponent from "@store/Library/Components/Toolkit/Layout/AccountLayout";
import React, { FC } from "react";

const AccountLayout: FC<WidgetProps> = ({ id }) => <AccountLayoutComponent id={id} />;

const widgetModule: WidgetModule = {
    component: AccountLayout,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Account Layout",
        icon: "table-layout",
        allowedContexts: [],
    },
};

export default widgetModule;
